import {IEnumListEntry} from "../definitions";
export const DEF_INPUT_SIZE:number = 6;


export enum VALUE_TYPE {
    INT,
    UINT,
    UINT_GT_ZERO,
    RATIONAL,
    RATIONAL_GTE_ZERO,
    ARRAY_UINT,
    ARRAY_RATIONAL,
    JSON
}


export function getExpectedValueTypeDescription(v: VALUE_TYPE): string {
  switch (v) {
    case VALUE_TYPE.INT: return "Требуется целое число.";
    case VALUE_TYPE.UINT: return "Требуется целое число >= 0.";
    case VALUE_TYPE.UINT_GT_ZERO: return "Требуется целое число > 0.";
    case VALUE_TYPE.RATIONAL: return "Требуется рациональное чило.";
    case VALUE_TYPE.RATIONAL_GTE_ZERO: return "Требуется рациональное чило >= 0.0.";
  }
  return null;
}


export enum ITEM_ID_TYPE {
    RESOURCE,
    QUEST,
    OFFERS_LOTS
}

export const GO_CATEGORY = [
  "STUFF",
  "COMMON_BUILDING",
  "DECOR"
]


export const GENERATOR_TYPES = {
  GARBAGE_GENERATOR: "GARBAGE_GENERATOR",
  NUT_GENERATOR: "NUT_GENERATOR",
  CHEST_GENERATOR: "CHEST_GENERATOR",
  SMMR_GENERATOR: "SMMR_GENERATOR"
}

export const DOCUMENT_TYPES = {
    QUESTS: "quest",
    QUEST_ARCS: "quest_arc",
    TEXT: "text",
    STORY: "story",
    ONMAP_DIALOG: "onmap_dialog",
    GO: "gameObject",
    PREM_SHOP_LOTS: "prem_shop_lot",
    PREM_SHOP_LEVELS: "prem_shop_level",
    OFFER_LOTS: "offer_lot",
    BUFF: "buff",
    SPELL: "spell",
    ACHIEVEMENT: "achievement",
    OFFER: "offer",
    LEVEL: "level",
    DROP: "drop_pack",
    SETTINGS: "settings",
    ADS_SETTINGS: "ads_settings",
    AD_NETWORK: "ad_network",
    WEIGHT: "weight",
    GENERATORS: "generators",
    CONSTS: "const",
    MAP_REFS: "mapRefs",
    ATLAS: "atlas",
    OFFERS_RESTRICTION_GROUP_FREQUENCY:"offers_restrictions_group_frequency",
    OFFERS_RESTRICTION_GROUP_RECENCY:"offers_restrictions_group_recency",
    OFFERS_RESTRICTION_GROUP_MONETARY:"offers_restrictions_group_monetary",
    LOCALE: "locale",
    GEO: "geo",
    GO_TAG: "go_tag",
    OFFER_TYPE: "offer_type",
    GAME_EVENT: "game_event",
    GAME_EVENT_MAP: "game_event_map",
    BLANK_PROFILE: "blank_profile",
    ORDER_TEMPLATE_TYPE: "order_template_type"
};

export const GENERATOR_TYPES_LIST:IEnumListEntry[] = Object.keys(GENERATOR_TYPES).map(key => {
  const id = GENERATOR_TYPES[key];
  const label = key;
  return <IEnumListEntry>{ id, label };
});


export const DOCUMENT_TYPES_LIST:IEnumListEntry[] = Object.keys(DOCUMENT_TYPES).map(key => {
  const id = DOCUMENT_TYPES[key];
  const label = key;
  return <IEnumListEntry>{ id, label };
});


export const COMPARATOR_TYPES = {
    GE: ">=",
    EQ: "=",
    LE: "<="
};


export const ALL_COMPARATORS:IEnumListEntry[] = [
    { id: COMPARATOR_TYPES.GE, label: ">=" },
    { id: COMPARATOR_TYPES.EQ, label: "==" },
    { id: COMPARATOR_TYPES.LE, label: "<=" },
];


export const SPECIAL_RES_STRATEGIES = [
  {algorithm:"random", config:{}},
  {algorithm:"consider_demand", config:{
      marketChance: 1.0,
      actionDropChance: 1.0,
      campChance: 1.0,
      dailyQuestChance: 1.0,
      zeppelinChance: 1.0
    }
  }
];


export enum APP_MESSAGES {
    ERROR,
    REMOTE_ERROR,
    JSON,
    WARNING,
    POPUP_CONFIRM,
    POPUP_MESSAGE,
    POPUP_QUERY__SELECT,
    POPUP_LOCALE_EDITOR,
    POPUP_SPINE_EDITOR_MODAL,
    POPUP_IMAGE_EDITOR_MODAL,
    POPUP_FMANAGER_MODAL,
    POPUP_HISTORY_JOURNAL,
    POPUP_META_IMPORT
}


export const SOCKET = {
    BROADCAST: "broadcast",
    BROADCAST_TYPES: {
        TIMEOUT: "timeout",
        DROP_ALL_LOCKS: "dropAllLocks",
        GOING_SHUTDOWN: "its going to shutdown",
        PACK_STARTED: "packStarted",
        PACK_FINISHED: "packFinished",
    }
};



// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/enums.ts